// extracted by mini-css-extract-plugin
export default {"gridDetails":"styles_gridDetails__pEpI4"};